import { createApiRef } from '@backstage/core-plugin-api';
import {
  RunTriggerResponse,
  RunTriggerOptions,
  TriggerListItem,
  ListTriggerOptions,
} from '@internal/backstage-plugin-cloudbuild-common';

/** @public */
export const triggerApiRef = createApiRef<TriggerApi>({
  id: 'plugin.cloudbuildtrigger.service',
});

/** @public */
export type TriggerApi = {
  listTriggers: (options: ListTriggerOptions) => Promise<TriggerListItem[]>;
  runTrigger: (options: RunTriggerOptions) => Promise<RunTriggerResponse>;
  invalidateCache?: () => void;
};
